function handleLoader(element) {
  if (element.dataset.remote === "true") {
    if (element.dataset.skipRemoteLoader === "true") {
      return
    }

    const loaderHandler = element.classList.contains("loader-handler")
      ? element
      : element.closest(".loader-handler")

    if (loaderHandler) {
      loaderHandler.classList.add("loading")
    }
  }
}

document.addEventListener("click", (e) => {
  const element = e.target.closest("[data-remote]")

  if (!element || element.tagName === "FORM") {
    return
  }

  handleLoader(element)
})

document.addEventListener("submit", (e) => {
  handleLoader(e.target)
})
